import PropTypes from "prop-types";

import StraightLineTool, {
  straightLinePropTypes,
  straightLineBaseDefaults,
} from "./StraightLineTool";
import EachTrendLine from "./wrapper/EachTrendLine";

// Config sobre StraightLineTool (auditoria 2026-07-17, item 1b).
// Wrapper compartilhado com TrendLine/Line — sempre foi EachTrendLine.
class Ray extends StraightLineTool {}

Ray.collectionKey = "rays";
Ray.EachComponent = EachTrendLine;
Ray.evoId = "interactive-ray";

Ray.propTypes = {
  ...straightLinePropTypes,
  type: PropTypes.oneOf(["RAY"]),
  rays: PropTypes.array.isRequired,
};

Ray.defaultProps = {
  ...straightLineBaseDefaults,
  type: "RAY",
  rays: [],
};

export default Ray;
